import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-blue-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M20 8V4H14V8H20Z" fill={textColor} />
    <path d="M15 14V10H9V14H15Z" fill={textColor} />
    <path d="M10 20V16H4V20H10Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M24.96 11.52V7.04004L16.96 7.04004V11.52H24.96Z"
      fill={textColor}
    />
    <path d="M20 18.2398V13.7598H12V18.2398H20Z" fill={textColor} />
    <path d="M15.2727 24.96V20.48H7.27271V24.96H15.2727Z" fill={textColor} />
  </>
);

export const HundredPointsIcon = createSlideIcon(Icon24x24, Icon32x32);
